import {Col, Container, OverlayTrigger, Row, Tooltip} from 'react-bootstrap';
import HoursForMsisdns from './HoursForMsisdns';
import ClaimGuard from "../../components/Auth/ClaimGuard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {GET_HOURS} from "../../Claims";
import React, {useEffect, useState} from "react";
import PdfHoursExport from "../../components/core/Pdf/PdfHoursExport";
import {useTranslation} from "react-i18next";
import {getGeofenceTransactionsForMsisdns} from "../../API/msisdnApi";
import {getTimelineEventsForMsisdns} from "../../API/timelineApi";
import messageFromError from "../../utils/errorUtils";
import {toast} from "react-toastify";
import ConditionalRender, {Fallback} from "../../components/ConditionalRender";
import PageLoader from "../../components/PageLoader";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import IconButton from "../../components/IconButton";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import useMyTranslation from "../../Hooks/useMyTranslation";

const HoursPage = () => {
    const navigate = useNavigate()
    const [params] = useSearchParams()
    const {i18n} = useTranslation()
    const t = useMyTranslation('pages.hoursOverview')

    const [selectedMsisdn, setSelectedMsisdn] = useState(null)
    const [transactions, setTransactions] = useState([])
    const [overlaps, setOverlaps] = useState([])
    const [events, setEvents] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const [selectedWeek, setSelectedWeek] = useState(null)

    const [isExporting, setIsExporting] = useState(false)
    const [shouldExport, setShouldExport] = useState(false)

    const [periodSelector, setPeriodSelector] = useState('week')

    useEffect(() => {

        async function fetchData()
        {
            setIsLoading(true)
            try {
                const [geofenceTransactionsResponse, timelineEventsResponse] = await Promise.all([
                    getGeofenceTransactionsForMsisdns([selectedMsisdn.msisdn], selectedWeek.startDate, selectedWeek.endDate, true),
                    getTimelineEventsForMsisdns([selectedMsisdn.msisdn], selectedWeek.startDate, selectedWeek.endDate, false, i18n.language)
                ])

                setTransactions(geofenceTransactionsResponse.data.transactions)
                setOverlaps(geofenceTransactionsResponse.data.overlaps)
                setEvents(timelineEventsResponse.data)
            }
            catch(error) {
                toast.error(messageFromError(error))
            }
            finally {
                setIsLoading(false)
            }
        }

        if (selectedMsisdn && selectedWeek?.startDate && selectedWeek?.endDate) {
            fetchData()
        }
    }, [selectedMsisdn, selectedWeek, i18n.language]);


    useEffect(() => {
        setPeriodSelector(params.get('periodSelector') || 'week')
    }, [params])

    useEffect(() => {
        if(!isExporting)
        {
            setShouldExport(false)
        }
    }, [isExporting]);

    return (
        <>
            <Container>
                <Row className="justify-content-center mt-4">
                    <Col md={12}>
                        <ClaimGuard requiredClaim={GET_HOURS} onUnauthorized={() => navigate('/') }>
                            <HoursForMsisdns
                                periodSelector={periodSelector}
                                transactions={transactions}
                                events={events}
                                onExport={() => setShouldExport(true)}
                                isExporting={isExporting}
                                isLoading={isLoading}
                                onMsisdnSelected={(msisdn) => setSelectedMsisdn(msisdn)}
                                onWeekSelected={(w) => setSelectedWeek(w)}
                            />
                        </ClaimGuard>
                    </Col>
                </Row>
            </Container>

            <ConditionalRender condition={periodSelector === 'week'}>
                <ConditionalRender condition={!isLoading}>
                    <Fallback>
                        <PageLoader small/>
                    </Fallback>
                    <ConditionalRender condition={selectedMsisdn}>
                        <Container fluid className={'pt-5 px-5'}>
                            <Row>
                                <Col className={'p-0'}>
                                    <div className={'bg-secondary-subtle shadow-sm rounded pb-1'}>
                                        <div
                                            className={'d-flex align-items-center bg-light justify-content-end p-2 border rounded-top border-dark-subtle'}>
                                            <div className={'border border-dark-subtle'}>
                                                <ConditionalRender condition={!isExporting}>
                                                    <Fallback>
                                                        <div
                                                            style={{backgroundColor: "white", borderRadius: 5, padding: 5}}>
                                                            <LoadingSpinner variant={'dark'} small/>
                                                        </div>
                                                    </Fallback>

                                                    <OverlayTrigger overlay={<Tooltip>{t('downloadInPdf')}</Tooltip>}>
                                                        <IconButton icon={faDownload} bg='white' onClick={(e) => {
                                                            e.stopPropagation();
                                                            setShouldExport(true)
                                                        }}/>
                                                    </OverlayTrigger>

                                                </ConditionalRender>
                                            </div>
                                        </div>
                                        <div className={'bg-light m-4 mt-3'}>
                                            <PdfHoursExport msisdn={selectedMsisdn}
                                                            selectedWeek={selectedWeek}
                                                            transactions={transactions}
                                                            overlaps={overlaps}
                                                            events={events}
                                                            onTransactionsChange={setTransactions}
                                                            onEventsChange={setEvents}
                                                            onExportStateChange={(state) => setIsExporting(state)}
                                                            shouldExport={shouldExport}
                                                            hidden={periodSelector !== 'week'}
                                                            showDaysBreakdown={false}
                                            />
                                        </div>
                                    </div>
                                    {/*<div className={'bg-secondary p-2 d-flex justify-content-between rounded-top'}>*/}
                                    {/*    <span className={'fw-bold text-light'}>PDF Preview</span>*/}
                                    {/*    <ConditionalRender condition={!isExporting}>*/}
                                    {/*        <Fallback>*/}
                                    {/*            <div style={{backgroundColor: "white", borderRadius: 5, padding: 5}}>*/}
                                    {/*                <LoadingSpinner variant={'dark'} small/>*/}
                                    {/*            </div>*/}
                                    {/*        </Fallback>*/}

                                    {/*        <IconButton icon={faDownload} bg='white' onClick={async (e) => {*/}
                                    {/*            e.stopPropagation();*/}
                                    {/*            setShouldExport(true)*/}
                                    {/*        }}/>*/}

                                    {/*    </ConditionalRender>*/}
                                    {/*</div>*/}
                                    {/*<div className={'shadow'}>*/}
                                    {/*    */}
                                    {/*</div>*/}
                                </Col>
                            </Row>
                        </Container>
                    </ConditionalRender>

                </ConditionalRender>
            </ConditionalRender>
        </>
    );
};

export default HoursPage;
